module.exports = __webpack_public_path__ + "media/images/rio-claro-logo-colorida-07b5484b.svg";